import { render, staticRenderFns } from "./CPSplash.vue?vue&type=template&id=4b007090&scoped=true&"
import script from "./CPSplash.vue?vue&type=script&lang=ts&"
export * from "./CPSplash.vue?vue&type=script&lang=ts&"
import style0 from "./CPSplash.vue?vue&type=style&index=0&id=4b007090&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b007090",
  null
  
)

export default component.exports